// app/frontend/pages/Onboarding/steps/StepGoals.tsx
import { Stack } from "@mantine/core";
import { StepShell } from "../../../components/ui/Stepper";
import { L2KTextarea } from "../../../components/ui/Forms";
import { L2KText } from "../../../components/ui/Typography";
import type { StepComponentProps } from "../../../components/ui/Stepper";
import type { OnboardingFormValues } from "../types";

const goalSuggestions = [
  "Learn the fundamentals",
  "Improve my musicality",
  "Become more confident social dancing",
  "Compete at events",
  "Learn new styles",
  "Meet other dancers",
];

export function StepGoals({ form }: StepComponentProps<OnboardingFormValues>) {
  const handleSuggestionClick = (suggestion: string) => {
    const currentGoals = form.values.dance_goals;
    if (currentGoals) {
      form.setFieldValue("dance_goals", `${currentGoals}\n${suggestion}`);
    } else {
      form.setFieldValue("dance_goals", suggestion);
    }
  };

  return (
    <StepShell
      title="What are your dance goals?"
      subtitle="Tell us what you want to achieve"
    >
      <Stack gap="md">
        <L2KTextarea
          label="Your goals"
          placeholder="I want to..."
          minRows={4}
          maxRows={6}
          {...form.getInputProps("dance_goals")}
        />

        <Stack gap="xs">
          <L2KText variant="secondary" size="sm">
            Need inspiration? Click to add:
          </L2KText>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            {goalSuggestions.map((suggestion) => (
              <button
                key={suggestion}
                type="button"
                onClick={() => handleSuggestionClick(suggestion)}
                style={{
                  padding: "6px 12px",
                  borderRadius: "16px",
                  border: "1px solid rgba(255, 152, 0, 0.3)",
                  backgroundColor: "rgba(255, 152, 0, 0.1)",
                  color: "#F0F0F0",
                  fontSize: "13px",
                  fontFamily: "'Public Sans', sans-serif",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(255, 152, 0, 0.2)";
                  e.currentTarget.style.borderColor = "#FF9800";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(255, 152, 0, 0.1)";
                  e.currentTarget.style.borderColor = "rgba(255, 152, 0, 0.3)";
                }}
              >
                {suggestion}
              </button>
            ))}
          </div>
        </Stack>
      </Stack>
    </StepShell>
  );
}

export default StepGoals;
